// extracted by mini-css-extract-plugin
module.exports = {"item":"item--1md64"};